// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import { collection, doc, getDoc, getFirestore, updateDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import { useAuthState } from "react-firebase-hooks/auth";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import { useCollection, useCollectionData, useDocumentData } from "react-firebase-hooks/firestore";
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
import { fetchAllAssignmentMetaData, fetchAssignments } from "../../utils/general";
import {useAuthUid} from 'hooks/user/useUserId';
import { getAssignmentMetadataCollection, type AssignmentMetadata } from "assignments/models/assignmentMetadata";
import type { ProjectId } from "projects/types";
import type { AssignmentId } from "assignments/types";
import { getUserAssignmentMapDocumentRef, type UserAssignmentMap } from "../../firebase/models/userAssignmentMap";
import { getProjectDocumentRef, type ProjectDocument } from "projects/projectDocument";

/**
 * Assignments are reactive to the firebase, so if you change
 * the value there, everyones assignment list will update!
 */

export type AssnMetadataType = {
    title: string,
    type: string,
}

export interface AssignmentContextData {
  assignments: AssignmentMetadata[];
  assnMetaData: Record<AssignmentId, AssignmentMetadata>;
  assnLoaded: boolean;
  assnMap: UserAssignmentMap | undefined;
  creativeProjects: ProjectId[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  creativeMetaData: Record<ProjectId, any>;
  creativeLoaded: boolean;
  deleteCreativeProject: (deletedProjectId: ProjectId) => Promise<void>;
}

const defaultData: AssignmentContextData = {
    assignments: undefined,
    assnMetaData:undefined,
    assnLoaded:false,
    assnMap:undefined,

    creativeProjects:undefined,
    creativeMetaData:{},
    creativeLoaded:false,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
    deleteCreativeProject: async (deletedProjectId: ProjectId) => {},
};

export const AssnContext = React.createContext<AssignmentContextData>(defaultData);

/**
 * Provides the course's assignments and the signed-in user's assignment
 * state.
 *
 * @param props.courseId - The course whose assignments to provide.
 * @param props.children - The subtree that reads the assignments.
 * @return The provider. With no signed-in user it provides the default
 *   context value and reads nothing.
 * @throws Never.
 */
export const AssnProvider = ({courseId, children}) => {
  const userId = useAuthUid();
  if (!userId) {
    return (
      <AssnContext.Provider value={defaultData}>{children}</AssnContext.Provider>
    );
  }
  return (
    <UserAssnProvider userId={userId} courseId={courseId}>
      {children}
    </UserAssnProvider>
  );
};

const UserAssnProvider = ({userId, courseId, children}) => {

  // Note: you do *not* currently have project meta data for assignments here
  // it is just links. You can get the meta data for the project by
  // loading each project id

  
  const db = getFirestore()

  // these are the refs we read (to start)
  const assnRef = doc(db, `assns/${courseId}`);
  const assnCollectionRef = getAssignmentMetadataCollection(courseId);
  const creativeRef = doc(db,`/users/${userId}/${courseId}/creativeProjects`)
  const assnMapRef = getUserAssignmentMapDocumentRef({
    userId,
    courseId,
  });
  

  // all of this is state on the assignments (and the meta data)
  const [assignmentDoc, assnDataIsLoading] = useDocumentData(assnRef)
  const [assignments, setAssignments] = useState(undefined)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const [assnMetaDataCollection, collectionDataLoading] = useCollection(assnCollectionRef)
  const [assnMetaData, setAssnMetaData] = useState(undefined)
  const [assnLoaded, setAssnLoaded] = useState(false)

  // see which projects have been completed
  
  // all of this is state on the creative projects (and the meta data)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const [creativeDoc, creativeDocLoading, creativeDocError] = useDocumentData(creativeRef)
  const [creativeProjects, setCreativeProjects] = useState([])
  const [creativeMetaData, setCreativeMetaData] = useState<Record<ProjectId, ProjectDocument>>({})
  const [creativeLoaded, setCreativeLoaded] = useState(false)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  const [assnMapDoc, assnMapLoading, assnMapError] = useDocumentData(assnMapRef)

  // helper function to get info for a project
  const fetchCreativeProjectInfo = async (projectId) => {
    const projMetaData = (await getDoc(getProjectDocumentRef(projectId))).data();
    setCreativeMetaData((prev) => {
      const newValue = {...prev}
      newValue[projectId] = projMetaData
      return newValue
    })
  };


  const deleteCreativeProject = async (projectId) => {
    const db = getFirestore();
    const docRef = doc(db, `/users/${userId}/${courseId}/creativeProjects`);
    const newCreativeProjects = creativeProjects.filter((id) => id !== projectId)
    await updateDoc(docRef, {creativeProjects:newCreativeProjects, deletedProjects:firebase.firestore.FieldValue.arrayUnion(projectId)})
    setCreativeProjects(newCreativeProjects)
  }


  // process a change to the assignment doc
  useEffect(()=> {
    // only run this when loading is done
    if(assnDataIsLoading) return

    if(assignmentDoc && assignmentDoc.assns) {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      setAssignments(assignmentDoc.assns)
    } else {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      setAssignments([])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  }, [assnDataIsLoading])


  // when you get the list of creative project ids...
  useEffect(() => {
    if(creativeDoc) {
      const projs = creativeDoc.creativeProjects
      if(!projs) {
        // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
        setCreativeLoaded(true)
      } else {
        // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
        setCreativeProjects(projs)
        for(const projId of projs){
          fetchCreativeProjectInfo(projId)
        }
      }
    }
    if(!creativeDoc && !creativeDocLoading) {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      setCreativeLoaded(true)
    }
  }, [creativeDoc, creativeDocLoading])

  // process a change to meta data
  useEffect(() => {
    if(assnMetaDataCollection) {
      const metaData = {}
      const response = assnMetaDataCollection
      response.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        metaData[doc.id] = doc.data();
        // console.log('HERE', doc.id, doc.data())
        // look up the project info, go ahead and render without it
        // fetchAssnProjectInfo(doc.data().projectId)
      });
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      setAssnMetaData(metaData)
    }
  }, [assnMetaDataCollection])

  // check if you have loaded everything
  useEffect(() => {
    if(assignments && assnMetaData) {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
      setAssnLoaded(true)
    }
  }, [assnMetaData, assignments])

  // check if you have loaded creative
  useEffect(() => {
    if(!creativeDocLoading){
      let isDone = true
      for(const projectId of creativeProjects) {
        if(!(projectId in creativeMetaData)) {
          isDone = false
        }
      }
      if(isDone){
        // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
        setCreativeLoaded(true)
      }
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
  }, [creativeMetaData, creativeProjects])

  const fullyLoadedAssn = assnLoaded
  return (
    <AssnContext.Provider
      value={{
        assignments,
        assnMetaData,
        assnMap: assnMapDoc,
        assnLoaded:fullyLoadedAssn,
        creativeProjects,
        creativeMetaData,
        creativeLoaded,
        deleteCreativeProject
      }}
    >
      {children}
    </AssnContext.Provider>
  );
};
